const MiniCart = {
  init() {
    this.activateCloser();
    this.activateOpener();
    // this.activatePopup();
  },
  // activatePopup() {
  //   $('body').on('added_to_cart', function () {
  //     $('.minicart').addClass('visible');

  //     // $('#single-product-notice').slideDown();

  //     // setTimeout(function () {
  //     //   $('#single-product-notice').slideUp();
  //     // }, 3600);
  //   });
  // },

  activateOpener() {
    $('.minicart-btn').on('click', function () {
      $('.minicart').parent().toggleClass('minicart-active');
    });
  },
  activateCloser() {
    $('.minicart-bg, .minicart-closer').on('click', () => {
      $('.minicart').parent().removeClass('minicart-active');
    });
  },
  updateCounter() {
    const count = $('.minicart-count');
    const length = $('.mini-cart-product').length;
    count.toggleClass('hidden', !length);
    count.html(length);
  },
  updateWidget() {
    let _this = this;
    jQuery.ajax({
      url: window.woocommerce_params.ajax_url,
      type: 'post',
      data: {
        action: 'ajax_update_mini_cart',
      },
      success: function (response) {
        $('.minicart').replaceWith(response);
        // $('*[data-toggle-mini-cart]').off('click');
        _this.activateCloser();
        _this.updateCounter();
      },
    });
  },
};

export default MiniCart;
